'use client';
import Image from 'next/image';
import { useState } from 'react';

export default function FleetResetPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await fetch('/api/auth/reset/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const j = await res.json();
      if (!res.ok || !j?.success) throw new Error(j?.error || 'Failed to send reset email');
      setSent(true);
    } catch (e:any) {
      setError(e?.message || 'Failed to send reset email');
    }
  };

  return (
    <div className="fleet-theme" style={{ background: 'var(--fleet-bg)', color: 'var(--fleet-text)', minHeight: '100vh' }}>
      <div className="relative z-10 flex min-h-screen items-center justify-center px-6 py-12">
        <div className="w-full max-w-md rounded-2xl p-8" style={{ background: 'var(--fleet-panel)', border: '1px solid var(--fleet-border)', boxShadow: 'var(--fleet-shadow)' }}>
          <div className="mb-6 text-center">
            <Image src="/logo.svg" alt="Smart Taurus" width={140} height={40} className="mx-auto mb-4" />
            <h2 className="text-2xl font-semibold tracking-tight" style={{ color: 'var(--fleet-text)' }}>Reset password</h2>
            <p className="text-sm mt-1" style={{ color: 'var(--fleet-muted)' }}>We’ll email you a link to reset your password.</p>
          </div>
          {sent ? (
            <div className="text-sm text-center" style={{ color: 'var(--fleet-text)' }}>
              If an account exists for <span className="font-medium">{email}</span>, we’ve sent a reset link.
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="block text-sm mb-1" style={{ color: 'var(--fleet-muted)' }}>Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e)=> setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="w-full rounded px-3 py-2 text-sm"
                  style={{ background:'var(--fleet-subtle)', border:'1px solid var(--fleet-border)', color:'var(--fleet-text)' }}
                />
              </div>
              {error && <div className="text-xs text-red-500">{error}</div>}
              <button type="submit" className="w-full rounded px-3 py-2 text-sm" style={{ background:'var(--fleet-indigo)', color:'#fff', border:'1px solid var(--fleet-border)' }}>
                Send reset link
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

;(FleetResetPage as any).noSidebar = true;
;(FleetResetPage as any).noFleetHeader = true;


